<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">地面运行起飞前故障决策</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="goTask">
          <img src="@/assets/images/yi.png" />历史记录
        </div>
        <div class="decision-head-bt active" @click="$router.push('/index')">
          <img src="@/assets/images/yi2.png" />回到首页
        </div>
      </div>
    </div>
    <div class="decision-page">
      <div class="decision-left active">
        <div class="malfunction-head">
          <div class="malfunction-head-laber">
            故障信息<span @click="clickCarousel()">查看故障照片/信息 ></span>
          </div>
          <div class="malfunction-head-p">
            {{ checkNull(errorDetail, "fullFaultMessage") }}
          </div>
        </div>
        <div class="malfunction-page">
          <iframe
            ref="iframeMEL"
            :src="checkNull(errorDetail, 'html')"
            style="width: 100%;height: 710px"
            @load="iframeOnLoad"
          />
        </div>
      </div>
      <div class="decision-right">
        <div class="malfunction-top">
          <div class="malfunction-top-li">
            <div class="malfunction-top-h">
              {{ checkNull(errorDetail, "planeType") }}
            </div>
            <div class="malfunction-top-p">飞机类别</div>
          </div>
          <div class="malfunction-top-li">
            <div class="malfunction-top-h">
              {{ checkNull(errorDetail, "flightNo") }}
            </div>
            <div class="malfunction-top-p">航班号</div>
          </div>
          <div class="malfunction-top-li">
            <div class="malfunction-top-h">
              {{ checkNull(errorDetail, "planeId") }}/{{
                checkNull(errorDetail, "msn")
              }}
            </div>
            <div class="malfunction-top-p">注册号/MSN编号</div>
          </div>
        </div>
        <div class="malfunction-center">
          <div class="malfunction-left">
            <img
              v-show="checkNull(errorDetail, 'lastResult') === 'R2'"
              src="@/assets/images/btt1.png"
              @click="showConclusion('R2')"
            />
            <img
              v-show="checkNull(errorDetail, 'lastResult') === 'R3'"
              src="@/assets/images/btt2.png"
              @click="showConclusion('R3')"
            />
            <img
              v-show="checkNull(errorDetail, 'lastResult') === 'R1'"
              src="@/assets/images/btt3.png"
              @click="showConclusion('R1')"
            />
            <img
              v-show="checkNull(errorDetail, 'lastResult') === 'R4'"
              src="@/assets/images/btt4.png"
              @click="showConclusion('R4')"
            />
          </div>
          <div class="malfunction-right">
            <div class="malfunction-right-h">{{ remindTimeShow }}</div>
            <div
              class="malfunction-right-p"
              v-show="checkNull(errorDetail, 'lastResult') === 'R3'"
            >
              请在倒计时结束前决策
            </div>
            <div
              class="malfunction-right-p"
              v-show="checkNull(errorDetail, 'lastResult') !== 'R3'"
            >
              本次决策用时
            </div>
          </div>
        </div>
        <div class="malfunction-bottom">
          <div class="malfunction-navBox">
            <div
              class="malfunction-nav"
              @click="tabClick(0)"
              :class="{ active: tab == 0 }"
            >
              <span
                :style="
                  `width: 12px;height: 12px;background: ${resultColor(
                    pilotHandDetail
                  )};border-radius: 6px;margin-right: 5px`
                "
              />PILOT
            </div>
            <div
              class="malfunction-nav"
              @click="tabClick(1)"
              :class="{ active: tab == 1 }"
            >
              <span
                :style="
                  `width: 12px;height: 12px;background: ${resultColor(
                    socHandDetail
                  )};border-radius: 6px;margin-right: 5px`
                "
              />SOC
            </div>
            <div
              class="malfunction-nav"
              @click="tabClick(2)"
              :class="{ active: tab == 2 }"
            >
              <span
                :style="
                  `width: 12px;height: 12px;background: ${resultColor(
                    mechHandDetail
                  )};border-radius: 6px;margin-right: 5px`
                "
              />MECH
            </div>
          </div>
          <div class="communicate-box">
            <div>
              <div class="soc-box" :class="{ hide: tab != 0 }">
                <!--  <div class="pilot-box">开启第三方沟通页面</div>-->
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">1.是否有O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionOne"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionOne"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                  <div
                    class="soc-bottom"
                    v-show="pilotHandDetail.pilotQuestionOne"
                  >
                    <div class="soc-left">是否等效执行O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionOneMore"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionOneMore"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">
                      2.携带故障运行队飞机操作点印象是否能接受？
                    </div>
                    <div class="soc-right">
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionSecond"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionSecond"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">3.注意事项相关要求是否满足？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionThird"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="pilotHandDetail.pilotQuestionThird"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                  <div
                    class="soc-bottom"
                    v-show="
                      pilotHandDetail.pilotQuestionThird !== undefined &&
                        !pilotHandDetail.pilotQuestionThird
                    "
                  >
                    <el-select v-model="pilotHandDetail.pilotQuestionThirdMore">
                      <el-option value="QA0" label="机组资质不满足" disabled />
                      <el-option value="QA1" label="必要设备不满足" disabled />
                      <el-option value="QA2" label="运行环境不达标" disabled />
                      <el-option value="QA3" label="其他" disabled />
                    </el-select>
                  </div>
                  <el-input
                    v-show="pilotHandDetail.pilotQuestionThirdMore === 'QA3'"
                    type="textarea"
                    v-model="pilotHandDetail.pilotQuestionThirdMoreComment"
                    placeholder="请输入原因"
                    readonly
                  ></el-input>
                </div>
              </div>
            </div>
            <div>
              <div class="soc-box" :class="{ hide: tab != 1 }">
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">1.是否有O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="socHandDetail.socQuestionOne"
                        :label="true"
                        @click.native.prevent
                        >是</el-radio
                      >
                      <el-radio
                        v-model="socHandDetail.socQuestionOne"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                  <div class="soc-bottom" v-show="socHandDetail.socQuestionOne">
                    <div class="soc-left">是否等效执行O程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="socHandDetail.socQuestionOneMore"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="socHandDetail.socQuestionOneMore"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">3.注意事项相关要求是否满足？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="socHandDetail.socQuestionSecond"
                        :label="true"
                        @click.native.prevent
                        >是
                      </el-radio>
                      <el-radio
                        v-model="socHandDetail.socQuestionSecond"
                        :label="false"
                        @click.native.prevent
                        >否
                      </el-radio>
                    </div>
                  </div>
                  <div
                    class="soc-bottom"
                    v-show="
                      socHandDetail.socQuestionSecond !== undefined &&
                        !socHandDetail.socQuestionSecond
                    "
                  >
                    <el-select v-model="socHandDetail.socQuestionSecondMore">
                      <el-option value="QA0" label="机组资质不满足" disabled />
                      <el-option value="QA1" label="必要设备不满足" disabled />
                      <el-option value="QA2" label="运行环境不达标" disabled />
                      <el-option value="QA3" label="其他" disabled />
                    </el-select>
                  </div>
                  <el-input
                    v-show="socHandDetail.socQuestionSecondMore === 'QA3'"
                    type="textarea"
                    v-model="socHandDetail.socQuestionSecondMoreComment"
                    placeholder="请输入原因"
                    readonly
                  ></el-input>
                </div>
              </div>
            </div>
            <div>
              <div
                class="soc-box"
                :class="{ hide: tab != 2 }"
                :style="noclick()"
              >
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">1.是否有M程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionOne"
                        :label="true"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="mechHandDetail.mechQuestionOne"
                        :label="false"
                        @input="
                          clearField(mechHandDetail, ['mechQuestionOneMore'])
                        "
                        >否
                      </el-radio>
                    </div>
                  </div>
                  <div
                    class="soc-bottom"
                    v-show="mechHandDetail.mechQuestionOne"
                  >
                    <div class="soc-left">是否等效执行M程序？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionOneMore"
                        :label="true"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="mechHandDetail.mechQuestionOneMore"
                        :label="false"
                        >否
                      </el-radio>
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">2.修理时限要求能否接受？</div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionSecond"
                        :label="true"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="mechHandDetail.mechQuestionSecond"
                        :label="false"
                        >否</el-radio
                      >
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">
                      3.目的地机场是否有机务人员办理相关MEL？
                    </div>
                    <div class="soc-right">
                      <el-radio
                        v-model="mechHandDetail.mechQuestionThird"
                        :label="true"
                        >是</el-radio
                      >
                      <el-radio
                        v-model="mechHandDetail.mechQuestionThird"
                        :label="false"
                        >否</el-radio
                      >
                    </div>
                  </div>
                </div>
                <div class="soc-li">
                  <div class="soc-top">
                    <div class="soc-left">
                      4.目的地机场必要设备能否保障（外部电源，气源）？
                    </div>
                    <div class="soc-right">
                      <el-radio
                        :label="true"
                        v-model="mechHandDetail.mechQuestionFour"
                        >是</el-radio
                      >
                      <el-radio
                        :label="false"
                        v-model="mechHandDetail.mechQuestionFour"
                        >否</el-radio
                      >
                    </div>
                  </div>
                </div>
                <div class="bt pb" @click="addRecordHandle" :style="noclick1()">
                  提交
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <finallys
      v-if="resultDailogFlag"
      :msg="resultComment"
      :reds="resultDailogFlag"
      @handle-close="handleClose"
      @ok="goTaskList"
    />
    <History
      v-if="isHistory"
      :dialogVisible="isHistory"
      client="ROLE_MECH"
      @handle-close="closeHistory"
    ></History>
    <Carousel
      v-if="carouselDialog"
      :showDialog="carouselDialog"
      @handle-close="closeCarousel"
      :imgs="imgs"
    ></Carousel>
  </div>
</template>

<script>
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import { addErrorRecordHandle, planeErrorDetail } from "@/api/api";
import History from "@/components/History";
import finallys from "@/components/finally";
import Carousel from "@/components/Carousel";
import MixinMqttClient from "@/components/mqtt/MixinMqttClient";

export default {
  name: "decision",
  components: { finallys, History, Carousel },
  mixins: [MixinMqttClient],
  data() {
    return {
      tableData: [
        {
          date: "C",
          date2: "1",
          date3: "0",
          date4: "是"
        }
      ],
      active: 0,
      nav: 0,
      radio: "1",
      tab: 2,
      id: "",
      errorDetail: null,
      pilotHandDetail: {},
      mechHandDetail: {
        mechQuestionOne: null,
        mechQuestionOneMore: null,
        mechQuestionSecond: null,
        mechQuestionThird: null,
        mechQuestionFour: null
      },
      socHandDetail: {},
      remindTimeShow: "00:00",
      timeInterval: undefined,
      remindTime: 0,
      submitFlag: false,
      resultDailogFlag: false,
      resultComment: undefined,
      isHistory: false,
      carouselDialog: false,
      imgs: []
    };
  },
  //todo mel转成html pilot的决策是开启三方？ 做完决策之后是不是不能编辑  查看故障信息照片/重新选择缺失
  created() {
    this.id = this.$route.params.id;
    this.getPlaneErrorDetail();
    // console.log(['created containsM',this.$refs.iframeMEL])
    // console.log(['created containsM',this.$refs.iframeMEL.contentWindow.containsM()])
  },
  mounted() {
    this.timeInterval = window.setInterval(() => {
      this.startInterval();
    }, 1000);
    // this.iframeOnLoad()
    this.subscribeTopic();
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
    if (this.topic) {
      this.unsubscribeMQTT(this.topic);
    }
  },
  computed: {
    enableMQTT() {
      if (this.disabledMQTT) {
        return false;
      }
      if (
        isNull(this.errorDetail) ||
        isUndefined(this.errorDetail.done) ||
        isNull(this.errorDetail.done)
      ) {
        return false;
      }
      if (this.errorDetail.done) {
        return false;
      }
      if (!this.id) {
        return false;
      }
      return true;
    },
    topic() {
      return this.enableMQTT ? `PlaneErrorRecordService/${this.id}` : "";
    }
  },
  watch: {
    enableMQTT(newValue){
      if (newValue) {
        this.subscribeTopic()
      } else if (this.topic) {
        this.unsubscribeMQTT(this.topic);
      }
    },
    topic(newValue, oldValue) {
      if (newValue) {
        this.subscribeTopic();
      } else if (oldValue) {
        this.unsubscribeMQTT(oldValue);
      }
    }
  },
  methods: {
    tabClick(e) {
      // console.log(e)
      this.tab = e;
    },
    async getPlaneErrorDetail() {
      const res = await planeErrorDetail({ id: this.id });
      if (res.code === "A00000") {
        this.errorDetail = res.data[0];
        if (
          this.errorDetail &&
          this.errorDetail.handleMap &&
          this.errorDetail.handleMap.ROLE_PILOT
        ) {
          this.pilotHandDetail = this.errorDetail.handleMap.ROLE_PILOT;
        }
        if (
          this.errorDetail &&
          this.errorDetail.handleMap &&
          this.errorDetail.handleMap.ROLE_SOC
        ) {
          this.socHandDetail = this.errorDetail.handleMap.ROLE_SOC;
        }
        if (
          this.errorDetail &&
          this.errorDetail.handleMap &&
          this.errorDetail.handleMap.ROLE_MECH
        ) {
          this.mechHandDetail = this.errorDetail.handleMap.ROLE_MECH;
        }
        this.iframeOnLoad();
        // console.log(['this.mechHandDetail', this.mechHandDetail])
        if (
          this.errorDetail &&
          this.errorDetail.lastResult &&
          this.errorDetail.lastResult === "R3"
        ) {
          var now = new Date().getTime();
          var seconds = new Date(this.errorDetail.createTimeFormat).getTime();
          //    var seconds1 = Date.parse(this.errorDetail.createTime).getSeconds();
          console.log(`now-->${now} 开始-->${seconds}  差值${now - seconds}`);
          if (now - seconds > 300000) {
            this.remindTime = 0;
          } else {
            this.remindTime = 300 - Math.floor((now - seconds) / 1000);
          }
        } else {
          this.remindTimeShow = this.errorDetail.compileTime;
        }
      }
    },
    checkNull(obj, attr) {
      return attr && obj && obj[attr] ? obj[attr] : "";
    },
    startInterval() {
      this.remindTime -= 1;
      if (this.remindTime <= 0) {
        clearInterval(this.timeInterval);
      }
      if (this.remindTime < 0) return;
      var m = Math.floor(this.remindTime / 60);
      var s = this.remindTime % 60;
      this.remindTimeShow = `0${m}:${s < 10 ? "0" + s : s}`;
    },
    async addRecordHandle() {
      this.mechHandDetail.recordId = this.id;
      this.mechHandDetail.flightNo = this.checkNull(
        this.errorDetail,
        "flightNo"
      );
      this.mechHandDetail.remainTime = this.remindTimeShow.replace(":", "");
      if (!this.checkFiledAndWarn()) {
        this.$message.warning("请完成所有题目");
        return;
      }
      const res = await addErrorRecordHandle(this.mechHandDetail);
      if (res.code === "A00000") {
        this.$message.success("提交决策成功");
        clearInterval(this.timeInterval);
      } else {
        this.$message.error(res.message);
      }
    },
    subscribeTopic() {
      if (this.enableMQTT && this.topic) {
        this.subscribeMQTT(this.topic, message => {
          this.onMessage(message);
        });
      }
    },
    onMessage(message) {
      if (message) {
        const res = JSON.parse(message.toString());
        this.getPlaneErrorDetail();
        if (res && res.result && res.result !== "R3") {
          this.resultComment = res;
          this.resultDailogFlag = true;
        }
      }
    },
    goTask() {
      this.isHistory = true;
    },
    goTaskList() {
      this.$router.push("/task/ROLE_MECH");
    },
    resultColor(item) {
      if (!(item && item.lastResult)) return "#EBA967";
      if (item.lastResult === "R1") {
        return "#8EBF86";
      } else if (item.lastResult === "R2") {
        return "#E07073";
      } else if (item.lastResult === "R3") {
        return "#EBA967";
      }
    },
    noclick() {
      return this.mechHandDetail && this.mechHandDetail.lastResult
        ? "pointer-events: none"
        : "";
    },
    noclick1() {
      return this.mechHandDetail && this.mechHandDetail.lastResult
        ? "background: darkgray"
        : "";
    },
    clearField(obj, array) {
      array.forEach(attr => {
        if (obj[attr] !== undefined) {
          obj[attr] = undefined;
        }
      });
    },
    checkFiledAndWarn() {
      if (
        this.mechHandDetail.mechQuestionOne !== undefined &&
        this.mechHandDetail.mechQuestionSecond !== undefined &&
        this.mechHandDetail.mechQuestionThird !== undefined &&
        this.mechHandDetail.mechQuestionFour !== undefined
      ) {
        return (
          !this.mechHandDetail.mechQuestionOne ||
          this.mechHandDetail.mechQuestionOneMore !== undefined
        );
      }
      return false;
    },
    handleClose() {
      this.resultDailogFlag = false;
    },
    closeHistory() {
      this.isHistory = false;
      //  this.getPlaneErrorDetail().finally(()=>{this.isHistory = false})
    },
    clickCarousel() {
      this.imgs = this.errorDetail.errorImages
        ? this.errorDetail.errorImages
        : [];
      if (this.errorDetail.errorMedia) {
        this.errorDetail.errorMedia.forEach(media => {
          this.imgs.push(media);
        });
      }
      if (this.imgs.length === 0) {
        this.$message.warning("暂无故障照片/信息");
      }
      this.carouselDialog = this.imgs.length > 0;
    },
    closeCarousel() {
      this.carouselDialog = false;
    },
    showConclusion(type) {
      if (
        this.errorDetail &&
        this.errorDetail.done &&
        type === this.errorDetail.lastResult
      ) {
        this.resultComment = this.errorDetail;
        this.resultDailogFlag = true;
      }
    },
    iframeOnLoad() {
      // if (this.$refs.iframeMEL.contentWindow.containsM) {
      //   // /home/nanhang/nfs/CSGenData/html
      //   // sed -i "s/'M'/'(M)'/g" ./*/*/*.html
      //   const containsM = this.$refs.iframeMEL.contentWindow.containsM();
      //   // console.log(['iframeOnLoad containsM', containsM])
      //   this.mechHandDetail.mechQuestionOne = containsM;
      // } else {
      //   this.mechHandDetail.mechQuestionOne = false;
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.soc-bottom {
  height: 46px !important;
}

/deep/ .el-select {
  width: 100%;

  .el-input__inner {
    background: #2f323d;
    border-radius: 8px;
    border: none;
    font-size: 16px;
  }
}

/deep/ .el-textarea textarea {
  background: #171821;
  border-radius: 8px;
  color: #fff;
  height: 80px;
  border: none;
  margin-top: 12px;
  padding: 10px 16px;
}

/deep/ .soc-bottom .el-input__inner {
  background: none;
  padding: 0;
}

/deep/ .el-table {
  margin-bottom: 15px;
}

/deep/ .el-radio {
  color: #fff;
}

/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  background: #272833;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  border-right: 1px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.87);
  opacity: 0.87;
  text-align: center;
}

/deep/ .el-table td.el-table__cell:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.6);
  opacity: 0.87;
}

/deep/ .el-table tr {
  background: #272833;
}

/deep/
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background: #171821;
}

/deep/ .el-table th.el-table__cell {
  background: #272833;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  border-right: 1px solid rgba(255, 255, 255, 0.6);
  border-top: 1px solid rgba(255, 255, 255, 0.6);
  color: rgba(255, 255, 255, 0.87);
  text-align: center;
  opacity: 0.87;
}

/deep/ .el-table th.el-table__cell:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.6);
}

/deep/ .el-table--border::after,
.el-table--group::after,
.el-table::before {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/malfunction/malfunctionMech.vue